var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClapperboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: "0px",
    x: "0px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\u5716\\u5C64_1",
    width: "100px",
    height: "100px",
    style: {
      width: "100%",
      height: "100%",
      backgroundSize: "initial",
      backgroundRepeatY: "initial",
      backgroundRepeatX: "initial",
      backgroundPositionY: "initial",
      backgroundPositionX: "initial",
      backgroundOrigin: "initial",
      backgroundImage: "initial",
      backgroundColor: "rgb(255, 255, 255)",
      backgroundClip: "initial",
      backgroundAttachment: "initial",
      animationPlayState: "paused"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)",
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    height: 33.8,
    width: 71.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#666868",
    y: 54.1,
    x: 16.1,
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(102, 104, 104)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "87.5,40.1 67.5,40.1 53.5,54.1 74.6,54.1 87.5,41.2",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#FFFFFF",
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.6,40.1 16.6,54.1 36.3,54.1 50.3,40.1",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#FFFFFF",
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.1,40.1 16.1,54.1 16.6,54.1 30.6,40.1",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#B2B3B4",
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(178, 179, 180)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.3,40.1 36.3,54.1 53.5,54.1 67.5,40.1",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#B2B3B4",
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(178, 179, 180)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.5,41.2 74.6,54.1 87.5,54.1",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#B2B3B4",
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(178, 179, 180)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "81.4,8.1 62.2,13.3 52.3,30.4 72.6,25 81.7,9.1",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#FFFFFF",
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.5,22.8 16.5,40 35.6,34.9 45.5,17.7",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#FFFFFF",
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.5,26.6 16.1,40.1 16.5,40 26.5,22.8",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#B2B3B4",
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(178, 179, 180)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.5,17.7 35.6,34.9 52.3,30.4 62.2,13.3",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#B2B3B4",
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(178, 179, 180)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.7,9.1 72.6,25 85.1,21.6",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#B2B3B4",
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(178, 179, 180)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "44.9,80.4 44.9,61.7 62.7,71",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    stroke: "#333333",
    fill: "#FFFFFF",
    style: {
      stroke: "rgb(51, 51, 51)",
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapperboard);
export default __webpack_public_path__ + "static/media/Clapperboard.516129b32c0074c17ff0de0d6d44d641.svg";
export { ForwardRef as ReactComponent };